/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Actions from '../../../actions'
import { routes } from '../../../consts'
import { ensureMediaPermissions } from '../../../utils/mediaPermissions'
import MediaDenied from '../MediaDenied'
import VideoPlayer from './VideoPlayer'
//TODO!! becasue logrocket issue!! -
// uncomment this code
// when zoom sdk will work with logrocket
// import VideoPlayerZoom from './VideoPlayerZoom'

export const VideoCall = () => {
  const dispatch = useDispatch()
  const [status, setStatus] = useState('disconnected')
  const { isMediaAllowed } = useSelector(state => state.app)
  const videoProps = useSelector(state => state.videoCall)
  const onEnd = () => {
    setStatus('disconnected')
    dispatch(Actions.createAction(Actions.CALL_ENDED_BY_PATIENT))
    dispatch(Actions.createAction(Actions.NAVIGATED_TO, routes.SURVEY_PAGE))
  }
  const onCompleted = useCallback(() => {
    setStatus('disconnected')
    dispatch(Actions.createAction(Actions.ROOM_COMPLETED))
    dispatch(Actions.createAction(Actions.NAVIGATED_TO, routes.SURVEY_PAGE))
  }, [])

  const onError = useCallback(
    error =>
      dispatch(Actions.createAction(Actions.OPERATION_FAILED, { error })),
    []
  )

  const getVideoPlayer = () => {
    return (
      <VideoPlayer
        onEnd={onEnd}
        onError={onError}
        onCompleted={onCompleted}
        setStatus={setStatus}
        {...videoProps}
      />
    )
    //TODO!! becasue logrocket issue!! -
    // uncomment this code and remove the above line
    // when zoom sdk will work with logrocket

    // return !videoProps.isZoom ? (
    //   <VideoPlayer
    //     onEnd={onEnd}
    //     onError={onError}
    //     onCompleted={onCompleted}
    //     setStatus={setStatus}
    //     {...videoProps}
    //   />
    // ) : (
    //   <VideoPlayerZoom
    //     onEnd={onEnd}
    //     onError={onError}
    //     onCompleted={onCompleted}
    //     setStatus={setStatus}
    //     status={status}
    //     {...videoProps}
    //   />
    // )
  }

  useEffect(() => {
    ensureMediaPermissions(dispatch)
  }, [])

  useEffect(() => {
    dispatch(
      Actions.createAction(Actions.VIDEO_CALL_STATUS_CHANGED, { status })
    )
  }, [status])
  return (
    <>
      {!isMediaAllowed && <MediaDenied />}
      {isMediaAllowed && getVideoPlayer()}
    </>
  )
}

export default VideoCall
